import _ from 'lodash';
import React from 'react';
import projectTaskStatuses from '~/lookups/project-task-statuses';
import MultiSelect from '../MultiSelect';

const options = _.values(projectTaskStatuses);

export default function ProjectTaskStatusFilter({ placeholder = 'Task Status', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
